import React from 'react';
import { createPortal } from 'react-dom';

import { mountRootParcel } from 'single-spa';
import Parcel from 'single-spa-react/parcel';

import { createReactRenderer } from 'helpers/react-renderer';
import { InvoicingConfig } from 'root/apps/QuoteMachineIntegration/common';
import { SystemJS } from 'root/apps/QuoteMachineIntegration/SystemJS';
import { getSessionData } from 'root/apps/QuoteMachineIntegration/utils/SessionData';
import Modules from 'root/apps/shared_modules/Modules';
import { datadogRum } from 'root/datadog/datadogRum';

import AutomatedAccountReceivablesService from '../services/AutomatedAccountReceivablesService';
import { AutomatedAccountReceivablesManagementType } from '../state/AutomatedAccountReceivablesManagementType';
import { AutomatedARManagementStatus } from '../state/AutomatedARManagementStatus';
import { handleClickOnAutomaticARRecipient } from '../utils/AutomaticARRecipientRedirect';

function AutomatedARManagementTool() {
  const [automationStatus, setAutomationStatus] = React.useState(AutomatedARManagementStatus.OFF);
  const [renderTarget, _] = React.useState<HTMLDivElement | null>(null);

  React.useEffect(() => {
    const fetchAutoARStatus = async () => {
      try {
        const res = await AutomatedAccountReceivablesService.getAutomatedAccountReceivablesStatus(
          AutomatedAccountReceivablesManagementType.ACCOUNT
        );
        setAutomationStatus(res);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        setAutomationStatus(AutomatedARManagementStatus.ERROR);
      }
    };
    fetchAutoARStatus();
  }, []);

  const anchorElement = React.useRef(
    document.querySelector(
      '[data-invoicing="invoicing-automated-account-receivables-credit-account-listing"]'
    )
  );

  // React.useEffect(() => {
  //   const targetDOM = anchorElement.current;
  //   if (!targetDOM) return () => {};
  //
  //   const div = document.createElement('div');
  //   targetDOM.parentNode?.insertBefore(div, anchorElement.current);
  //
  //   setRenderTarget(div);
  //
  //   return () => {
  //     targetDOM.parentNode?.removeChild(div);
  //   };
  // }, [anchorElement]);

  if (!anchorElement.current) return null;
  if (!renderTarget) return null;

  return createPortal(
    <Parcel
      key="automated-ar-management-tool"
      mountParcel={mountRootParcel}
      baseLocation="/?name=credit_account.listings.credit_accounts&form_name=listing"
      skipCSSUnmount={true}
      config={async () =>
        (await SystemJS.import<InvoicingConfig>('@lightspeed/invoicing')).default
          .AutomatedAccountReceivablesManagementBannerConfig
      }
      handleError={(err: Error) => datadogRum.addError(err)}
      context={AutomatedAccountReceivablesManagementType.ACCOUNT}
      automatedAccountReceivablesStatus={automationStatus}
      setAutomationStatus={setAutomationStatus}
      updateAutomatedAccountReceivablesStatus={(
        context: AutomatedAccountReceivablesManagementType,
        automationEnabled: boolean
      ) =>
        AutomatedAccountReceivablesService.updateAutomatedAccountReceivablesStatus(
          context,
          automationEnabled
        )
      }
      fetchActions={() => AutomatedAccountReceivablesService.fetchActions('')} // TODO:
      onRecipientClick={handleClickOnAutomaticARRecipient}
      loadToReviewPage={AutomatedAccountReceivablesService.getCreditAccountProfilesToReview}
      sessionData={getSessionData()}
    />,
    renderTarget
  );
}

const RenderedComponent = createReactRenderer({
  component: AutomatedARManagementTool,
  selector: '[data-react-root="AutomatedARManagementTool"]',
});

export default AutomatedARManagementTool;

window.history.onChangeState(
  {
    id: undefined,
    name: 'credit_account.listings.credit_accounts',
  },
  () => {
    if (Modules.hasModule('customers.invoicing_integration.free_tier')) {
      document
        .getElementById('listing')
        ?.setAttribute(
          'data-invoicing',
          'invoicing-automated-account-receivables-credit-account-listing'
        );
      RenderedComponent.mount();
    }
  },
  () => {
    RenderedComponent.unmount();
  }
);
